import { connect } from "react-redux";
import { actions, getters } from "EventLight/Sessions/AddSessionModal/model";

import MultiValueLabel from "EventLight/Sessions/Page/View/MultiValueLabel";

const decorate = connect(
  state => ({
    data: getters.data(state)
  }),
  {
    setSpeakerIsPublicInStore: actions.setSpeakerIsPublicInStore
  }
);

export default decorate(MultiValueLabel);
